// Action Types
export const LOAD_QUOTA = 'ACCOUNT_INVITATION_QUOTA_LOAD';
export const LOAD_QUOTA_SUCCESS = 'ACCOUNT_INVITATION_QUOTA_LOAD_SUCCESS';
export const LOAD_QUOTA_FAILED = 'ACCOUNT_INVITATION_QUOTA_LOAD_FAILED';

export const DISCONNECT = 'ACCOUNT_INVITATION_QUOTA_DISCONNECT';

/**
 * Load invitation quota for an account
 * @param {String} accountId - Account ID - It's optional; if not provided, current account from router will be used
 * @param {String} requesterId - Requester ID for tracking
 */
export const loadQuota = ({ accountId, requesterId }) => ({
  type: LOAD_QUOTA,
  accountId,
  requesterId
});

/**
 * Internal action for successful quota load
 */
export const _loadQuotaSuccess = ({ accountId, data }) => ({
  type: LOAD_QUOTA_SUCCESS,
  accountId,
  data
});

/**
 * Internal action for failed quota load
 */
export const _loadQuotaFailed = ({ accountId, error }) => ({
  type: LOAD_QUOTA_FAILED,
  accountId,
  error
});

/**
 * Disconnect quota listener for an account
 * @param {String} accountId - Account ID
 * @param {String} requesterId - Requester ID for tracking
 */
export const disconnect = ({ accountId, requesterId }) => ({
  type: DISCONNECT,
  accountId,
  requesterId
});
